const findPercent = (percentFrom, value) => {
  return Math.round((percentFrom * 100) / value);
};

export default findPercent;
